import "./index.scss";
import Tap from "../../assets/img/Green-Touch-Icon.gif";
import Logo from "../../components/icons/Logo";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../context/DataProvider";
import Pool from "../../components/icons/NavIcons/Pool";
import ShippingAndReceiving from "../../components/icons/NavIcons/ShippingAndReceiving";
import GrabNGoMarket from "../../components/icons/NavIcons/GrabNGoMarket";
import Lobby from "../../components/icons/NavIcons/Lobby";
import Valet from "../../components/icons/NavIcons/Valet";
import GiftShop from "../../components/icons/NavIcons/GiftShop";
import Office from "../../components/icons/NavIcons/Office";
import GuestroomsAndHousekeeping from "../../components/icons/NavIcons/GuestroomsAndHousekeeping";
import { Header } from "../../components/Header";
const HotelPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page splash hotelPage">
            <Header />
            <div className="page-header">Hotel</div>
            <div className="text-blocks">
                <div className="std-text">
                    Whether you offer guest rooms alone or are a
                    multi-amenity resort with a restaurant, bar, pool or
                    more, your property is a unique operation that
                    requires robust solutions supported by an
                    experienced technology partner.{'\n\n'}
                </div>
                <div className="std-text">
                    From reservations to front desk, housekeeping,
                    point of sale and property management, Agilysys
                    solutions have you covered.
                </div>
            </div>
            <div className="tap">
                <img src={Tap} alt="" />
                <div className="tap-prompt">
                    Tap on each section of the map{'\n'}
                    To drill into the details
                </div>
            </div>
            <div className="logo" onClick={()=>{
                _logEvent('click', "Hotel", "Agilysys");
                addFlow("Agilysys");
                navigate("/aboutus/agilysys");
            }}>
                <Logo />
            </div>

            <div className="hotel-map">
                <div className="pool">
                    <Pool onClick={()=>{
                        _logEvent('click', "Hotel", "Pool");
                        addFlow("Pool");
                        navigate("pool", { relative: "path" })
                    }}/>
                </div>
                <div className="shipping">
                    <ShippingAndReceiving onClick={()=>{
                        _logEvent('click', "Hotel", "Shipping & Receving");
                        addFlow("Shipping & Receiving");
                        navigate("shipping", { relative: "path" })
                    }}/>
                </div>
                <div className="market">
                    <GrabNGoMarket onClick={()=>{
                        _logEvent('click', "Hotel", "Grab N Go Market");
                        addFlow("Grab N Go Market");
                        navigate("gran-n-go", { relative: "path" })
                    }}/>
                </div>
                <div className="lobby">
                    <Lobby onClick={()=>{
                        _logEvent('click', "Hotel", "Lobby");
                        addFlow("Lobby");
                        navigate("lobby", { relative: "path" })
                    }}/>
                </div>
                <div className="valet">
                    <Valet onClick={()=>{
                        _logEvent('click', "Hotel", "Valet");
                        addFlow("Valet");
                        navigate("valet", { relative: "path" })
                    }} />
                </div>
                <div className="gift">
                    <GiftShop onClick={()=>{
                        _logEvent('click', "Hotel", "Gift Shop");
                        addFlow("Gift Shop");
                        navigate("gifts", { relative: "path" })
                    }} />
                </div>
                <div className="office">
                    <Office onClick={()=>{
                        _logEvent('click', "Hotel", "Office");
                        addFlow("Office");
                        navigate("office", { relative: "path" })
                    }} />
                </div>
                <div className="guest">
                    <GuestroomsAndHousekeeping onClick={()=>{
                        _logEvent('click', "Hotel", "Guest Rooms & Housekeeping");
                        addFlow("Guest Rooms & Housekeeping");
                        navigate("guest", { relative: "path" })
                    }} />
                </div>
            </div>
            {/* 
            <div className="pool-link link" onClick={()=>{
                _logEvent('click', "Hotel", "Pool");
                addFlow("Pool");
                navigate("pool", { relative: "path" })}}/>
            <div className="shipping-link link" onClick={()=>{
                _logEvent('click', "Hotel", "Shipping & Receving");
                addFlow("Shipping & Receiving");
                navigate("shipping", { relative: "path" })}}/>
            <div className="market-link link" onClick={()=>{
                _logEvent('click', "Hotel", "Grab N Go Market");
                addFlow("Grab N Go Market");
                navigate("gran-n-go", { relative: "path" })}}/>
            <div className="lobby-link link" onClick={()=>{
                _logEvent('click', "Hotel", "Lobby");
                addFlow("Lobby");
                navigate("lobby", { relative: "path" })}}/>
            <div className="valet-link link" onClick={()=>{
                _logEvent('click', "Hotel", "Valet");
                addFlow("Valet");
                navigate("valet", { relative: "path" })}}/>
            <div className="gift-link link" onClick={()=>{
                _logEvent('click', "Hotel", "Gift Shop");
                addFlow("Gift Shop");
                navigate("gifts", { relative: "path" })}}/>
            <div className="office-link link" onClick={()=>{
                _logEvent('click', "Hotel", "Office");
                addFlow("Office");
                navigate("office", { relative: "path" })}}/>
            <div className="guest-link link" onClick={()=>{
                _logEvent('click', "Hotel", "Guest Rooms & Housekeeping");
                addFlow("Guest Rooms & Housekeeping");
                navigate("guest", { relative: "path" })}}/>
            */}
        </div>
    )
}

export default HotelPage;